import React            from 'react';
import { Redirect }     from 'react-router-dom';
import EventStudentList from './EventStudentList';
import Gradebook        from './Gradebook';
import GradebookList    from './GradebookList';
import StudentGradebook from './StudentGradebook';
import GradebookSummary from './GradebookSummary';

export const GradebookConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path      : '/gradebook/student/event_list/:company_course_id/:student_id',
            component : StudentGradebook,
            permission: { component_name: 'gradebook', permission_type: 'read' },
        },
        {
            path      : '/gradebook/student/event_list/:company_course_id',
            component : StudentGradebook,
            permission: { component_name: 'gradebook', permission_type: 'read' },
        },
        {
            path      : '/grade/student/list/:event_id',
            component : EventStudentList,
            permission: { component_name: 'gradebook', permission_type: 'read' },
        },
        {
            path      : '/gradebook/list',
            component : GradebookList,
            permission: { component_name: 'gradebook', permission_type: 'read' },
        },
        {
            path      : '/gradebook/:company_course_id',
            component : Gradebook,
            permission: { component_name: 'gradebook', permission_type: 'read' },
        },
        {
            path      : '/gradebook',
            component : () => <Redirect to="/gradebook/list" />,
            permission: { component_name: 'gradebook', permission_type: 'read' },
        },
        {
            path      : '/gradebook_test',
            component : GradebookSummary,
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/gradebook/GradebookConfig.js